import axios from "axios";
import { configUrl } from "config";

export async function LeadGenerationService(studetnInfo) {
    console.log(studetnInfo, 'onNextPayload');

    return axios
        .post(
            `${configUrl.AssessmentServer}/api/Coupon/sendUserSignupInfoEmail  `, studetnInfo
        )
        .then((respose) => {
            console.log(respose.data, 'dataVals');
            return respose.data;
        })
        .catch((error) => {
            return {
                error: true,
                status: error?.response?.status,
                message: error?.response?.data || "Something went wrong"
            };
        });
}